import * as TypeGraphQL from "type-graphql";
export var ScheduledOptionOrderScalarFieldEnum;
(function (ScheduledOptionOrderScalarFieldEnum) {
    ScheduledOptionOrderScalarFieldEnum["id"] = "id";
    ScheduledOptionOrderScalarFieldEnum["payload"] = "payload";
    ScheduledOptionOrderScalarFieldEnum["status"] = "status";
})(ScheduledOptionOrderScalarFieldEnum || (ScheduledOptionOrderScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ScheduledOptionOrderScalarFieldEnum, {
    name: "ScheduledOptionOrderScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ScheduledOptionOrderScalarFieldEnum.js.map